import { DualProfile } from "./DualProfile";
export default DualProfile;
